import { PlyrComponent } from 'plyr-react';
import React, { useContext, useEffect } from 'react'
import { NavigationContext } from '../context/NavigationContext';
import Button from '../components/Button';

const VideoPresentation = () => {

    const { setPage, hideMenu } = useContext(NavigationContext)

    useEffect(() => {
        setPage('videos')
        hideMenu()
        window.scrollTo(0, 1)
    }, [])

    const longue = {
        type: 'video',
        sources: [
            {
                src: '430729235',
                provider: 'vimeo',
            },
        ]
    }

    const courte = {
        type: 'video',
        sources: [
            {
                src: '430730798',
                provider: 'vimeo',
            },
        ]
    }

    return (
        <div>
            <h1>Présentation de Pix</h1>
            <p>Dans cette vidéo, le reponsable de l'UV présente la certification PIX de façon générale (Son origine, son objectif, son contenu, etc).</p>
            <PlyrComponent sources={courte} />
            <br /><br />
            <h1>L'épreuve de certification Pix</h1>
            <p>Dans cette vidéo, le responsable de l'UV présente les modalités et le déroulement de l'épreuve de certification Pix.</p>
            <PlyrComponent sources={longue} />
            <div className="button-container">
                <Button icon="arrow-left" to="?page=videos">Toutes les vidéos</Button>
                <Button icon="arrow-right" to="?page=videos&id=organisation">Organisation de l'UV</Button>
            </div>
        </div>
    );
}

export default VideoPresentation;